function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCpTagging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.1108 12.1108H12.1204M6.34375 9.4195L6.34375 13.7203C6.34375 14.1905 6.34375 14.4255 6.39686 14.6468C6.44396 14.8429 6.52163 15.0304 6.62703 15.2024C6.74591 15.3964 6.91214 15.5627 7.24461 15.8951L14.6155 23.266C15.7574 24.4079 16.3284 24.9789 16.9867 25.1928C17.5659 25.381 18.1897 25.381 18.7689 25.1928C19.4272 24.9789 19.9982 24.4079 21.1401 23.266L23.266 21.1401C24.4079 19.9982 24.9789 19.4272 25.1928 18.7689C25.381 18.1897 25.381 17.5659 25.1928 16.9867C24.9789 16.3284 24.4079 15.7574 23.266 14.6155L15.8951 7.24462C15.5627 6.91214 15.3964 6.74591 15.2024 6.62703C15.0304 6.52163 14.8429 6.44396 14.6468 6.39686C14.4255 6.34375 14.1905 6.34375 13.7203 6.34375L9.4195 6.34375C8.34288 6.34375 7.80458 6.34375 7.39337 6.55327C7.03166 6.73757 6.73757 7.03165 6.55327 7.39337C6.34375 7.80458 6.34375 8.34288 6.34375 9.4195ZM12.5914 12.1108C12.5914 12.3762 12.3762 12.5914 12.1108 12.5914C11.8454 12.5914 11.6302 12.3762 11.6302 12.1108C11.6302 11.8454 11.8454 11.6302 12.1108 11.6302C12.3762 11.6302 12.5914 11.8454 12.5914 12.1108Z",
    stroke: "#2064FA",
    style: {
      stroke: "#2064FA",
      stroke: "color(display-p3 0.1255 0.3922 0.9804)",
      strokeOpacity: 1
    },
    strokeWidth: 2.13333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpTagging);
export default __webpack_public_path__ + "static/media/cp_tagging.db575a15be215ddbd2467cff377e01e1.svg";
export { ForwardRef as ReactComponent };